import { useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { useRouter } from 'next/router'
import Title from '../../common-components/Title'
import { getSlugifiedApi } from '../../utils/add-slugs-to-api'
import { fetchRequest } from '@/root/utils/network-adapter/fetch-request'

interface ICardsGridData {
  data?: {
    amc_detail?: Array<{
      subtitle?: string
      color_sub_title?: string
      color_title?: string
      title?: string
    }>
  }
}

const CardsGridV0Widget = ({ apiUrl }: { apiUrl: string }) => {
  const [cardsGridData, updateCardsGridData] = useState<ICardsGridData | null>()
  const { asPath } = useRouter()
  const slugs = asPath.split('/')

  const getFilterCall = async headers => {
    const resp = await fetchRequest({
      url: getSlugifiedApi(apiUrl, slugs),
      config: { headers },
    })
    return resp
  }

  const getFilterMutation = useMutation(getFilterCall)

  const updateFilter = () => {
    getFilterMutation.mutate(
      {},
      {
        onSuccess: resp => {
          if (resp) {
            updateCardsGridData(resp)
          }
        },
      },
    )
  }

  useEffect(() => {
    updateFilter()
  }, [asPath])

  if (getFilterMutation.isLoading) {
    return <div className="h-[228px] w-full lg:h-[130px]"> </div>
  }

  return cardsGridData?.data?.amc_detail?.length ? (
    <div className="flex flex-row flex-wrap justify-center gap-x-6 gap-y-4 lg:justify-start">
      {cardsGridData.data.amc_detail.map((opt, ind) => {
        return (
          <div
            className="border-brand-grey-light flex flex-col items-center rounded-lg border px-5 py-5 font-medium lg:px-8"
            key={ind}
          >
            {opt.title && (
              <Title
                className="flex flex-col text-center"
                fontSize="size-34"
                style={{ color: opt.color_title }}
                headingType="p"
              >
                {opt.title}
              </Title>
            )}
            {opt.subtitle && (
              <p
                dangerouslySetInnerHTML={{
                  __html: opt.subtitle,
                }}
                className="text-base"
                style={{ color: opt.color_sub_title }}
              />
            )}
          </div>
        )
      })}
    </div>
  ) : (
    <div />
  )
}

export default CardsGridV0Widget
